export interface LocaleUtilParams {
  locale?: Locale;
}

export class LocaleUtil {
  private locale: Locale = {};

  constructor(params?: LocaleUtilParams) {
    this.setLocale(params?.locale ?? {});
  }

  setLocale(locale: Locale) {
    this.locale = this.decodeLocale(locale);
  }

  decodeHtmlEntities(str: string) {
    return str
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&#39;/g, "'");
  }

  decodeLocale(locale: Locale) {
    const result = {} as Locale;

    for (const group in locale) {
      result[group] = {};
      for (const key in locale[group]) {
        result[group][key] = this.decodeHtmlEntities(locale[group][key]);
      }
    }

    return result;
  }

  translate(id: string, values?: Record<string, string>) {
    const [group, key] = id.split(".");
    const text = this.locale[group]?.[key];

    if (!text) {
      return `translation missing: ${id}`;
    }

    if (!values) {
      return text;
    }

    return Object.entries(values).reduce(
      (text, [key, value]) =>
        text.replace(new RegExp(`{{\\s*${key}\\s*}}`, "g"), value),
      text,
    );
  }
}

export type Locale = Record<string, Record<string, string>>;
